import { useContext, useMemo } from 'react';

import { AuthContext } from './auth.context';
import { AuthContextType } from '../../types/auth';

export const useAuthContext = (): AuthContextType => {
  const auth = useContext(AuthContext);

  if (!auth) throw new Error('useAuthContext is used outside of context');

  return auth;
};

export const useHasPermission = (permission: string): boolean => {
  const { currentUser } = useAuthContext();

  return useMemo(() => {
    if (!currentUser || !currentUser.permissions) {
      return false;
    }

    return currentUser.permissions.includes(permission);
  }, [currentUser, permission]);
};

export const useHasAnyPermission = (permissions: string[]): boolean => {
  const { currentUser } = useAuthContext();

  return useMemo(() => {
    if (!currentUser || !currentUser.permissions) {
      return false;
    }

    return permissions.some((permission) => currentUser.permissions.includes(permission));
  }, [currentUser, permissions]);
};
